import { createFileRoute } from '@tanstack/react-router'

import { AgreementReview } from '@/features/agreements/agreement-review'
import { handoverGate } from '@/features/handover/gate'

/**
 * A walk-in's agreement, at `/drives/{id}/agreement`.
 *
 * The same screen the booking's own route draws, addressed by the only id a walk-in has: it
 * writes no `bookings` row (ADR 0005), so there is no `$bookingId` to reach it by. The gate is
 * the one every hand-over screen stands behind — `sell` or above — and sends a read-only member
 * to the day rather than to a record that does not exist.
 */
export const Route = createFileRoute('/_app/drives/$driveId_/agreement')({
  ...handoverGate(),
  component: AgreementReview,
})
